import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Card, Row, Col, Layout, Image } from "antd";
import TraneTechnologiesBrand from "../Images/bg_tk.jpg";
import { getDefaultPath, isAuthTrueAndValid } from '../common/utils/authUtils';
import * as AlertActions from '../store/actions/alertActions';
import * as authActions from '../store/actions/authActions';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import OIP from "../Images/OIP.jpg";
import LOGO from "../Images/logonew.iix";

const { Header, Footer } = Layout;

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const imageRef = useRef(null);
  const handleLogin = async (values) => {
    setLoading(true);
    try {
      await props.loginUser({ UserName: values.username, Password: values.password });
    } catch (error) {
      console.error('Login error: ', error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setImageLoaded(true);
            console.log('entery: ', entry);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);

  return (props.userData && props.userData.auth) || isAuthTrueAndValid() ? (
    <Redirect
      to={{
        pathname: getDefaultPath(props.userData), //get the initial path based on role and screen
      }}
    />
  ) : (
    <>
      <Header style={{ background: "#fcf2e9", color: "#655ba0", height: "auto", padding: "0 1rem" }}>
        <div style={{ display: 'flex' }}>
          <Image src={LOGO} width={80} />
          <h2 style={{ height: 'auto', margin: 0, width: "90%" }}>ECoTRIP - Energy Consumption and Transport Refrigeration Insight Platform</h2>
        </div>
      </Header>
      <Row
        ref={imageRef}
        style={{
          height: "calc(100vh - 99px)",
          backgroundImage: imageLoaded ? `url(${TraneTechnologiesBrand})` : 'none',
          backgroundSize: "cover",
          width: "100%",
        }}
      >
        <Col xs={24} sm={18}>
          <div></div>
        </Col>
        <Col xs={24} sm={6} style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: 'max-content' }}>
            <Card style={{
              position: "relative", zIndex: 1,
              width: "310px", border: "2px solid black",
              backgroundColor: "transparent",
              background: "rgba(14, 14, 14, 0.25)",
              borderRadius: "16px",
              boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
              backdropFilter: "blur(13px)",
              border: "1px solid rgba(14, 14, 14, 0.26)",
            }}>
              <h2 style={{ textAlign: "center", color: 'white' }}>Login</h2>
              <Form name="login" onFinish={handleLogin}>
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your username",
                    },
                  ]}
                >
                  <Input placeholder="Corp-Id" size="large" />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your password",
                    },
                  ]}
                >
                  <Input.Password placeholder="Password" size="large" />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    size="large"
                    loading={loading}
                  >
                    Log in
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
      <Footer
        style={{
          textAlign: 'center',
          background: "#fcf2e9",
          color: "#655ba0",
          display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            padding: "10px 10px"
        }}
      >
      <h3 style={{
        position: "absolute",
            left: "50%",
            transform: "translateX(-50%)"
      }}>
        © {new Date().getFullYear()} Copyright: Trane Technologies
      </h3>
        <div className="version" style={{ marginLeft: "auto"}}>{process.env.REACT_APP_VERSION}</div>
      </Footer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    loginError: state.alert
  }
};

const mapDispatchToProps = (dispatch) => ({
  showAlertMessage: () => dispatch(AlertActions.showAlertMessage()),
  loginUser: (user) => dispatch(authActions.loginUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
